import React, { lazy, Suspense } from 'react';
import { Switch, Route } from 'react-router-dom';
import { makeStyles } from '@material-ui/core/styles';
import AuthProvider from 'context/AuthContext';
import ReLoading from 'components/ReLoading';

const HomePage = lazy(() => import(`./pages/home/HomePage`));
const SplashScreen = lazy(() => import(`./pages/SplashScreen`));
const LoginPage = lazy(() => import(`./pages/LoginPage`));
const OrderCategoryPage = lazy(() => import(`./pages/OrderCategoryPage`));
const MissingTokenPage = lazy(() => import(`./pages/MissingTokenPage`));
const ErrorPage = lazy(() => import(`./pages/ErrorPage`));
const SearchProductPage = lazy(() => import(`./pages/SearchProductPage`));
const FeedbackPage = lazy(() => import(`./pages/feedback/FeedbackPage`));
const CategoryPage = lazy(() => import(`./pages/CategoryPage`));
const SuggestionPage = lazy(() => import(`./pages/SuggestionPage`));
const TenantPage = lazy(() => import(`./pages/TenantPage`));
const MiniAppFailurePage = lazy(() => import(`./pages/MiniAppFailurePage`));

const useStyles = makeStyles({
  container: {
    margin: '0 auto',
    minHeight: '100vh',
  },
});

const Routes = () => {
  const classes = useStyles();

  return (
    <div className={classes.container} style={{ width: '100%' }}>
      <Suspense fallback={<ReLoading />}>
        <Switch>
          <Route
            exact
            path="/"
            render={(props) => (
              <AuthProvider>
                <ReLoading {...props} />
              </AuthProvider>
            )}
          />
          <Route
            exact
            path="/splash"
            render={(props) => (
              <AuthProvider>
                <SplashScreen {...props} />
              </AuthProvider>
            )}
          />
          <Route
            exact
            path="/login"
            render={(props) => (
              <AuthProvider>
                <LoginPage {...props} />
              </AuthProvider>
            )}
          />
          <Route
            exact
            path="/menu-catalogue"
            render={(props) => (
              <AuthProvider>
                <HomePage {...props} />
              </AuthProvider>
            )}
          />
          <Route
            exact
            path="/order-category"
            render={(props) => (
              <AuthProvider>
                <OrderCategoryPage {...props} />
              </AuthProvider>
            )}
          />
          <Route
            exact
            path="/search-product"
            render={(props) => (
              <AuthProvider>
                <SearchProductPage {...props} />
              </AuthProvider>
            )}
          />
          <Route
            exact
            path="/feedback"
            render={(props) => (
              <AuthProvider>
                <FeedbackPage {...props} />
              </AuthProvider>
            )}
          />
          <Route
            exact
            path="/category"
            render={(props) => (
              <AuthProvider>
                <CategoryPage {...props} />
              </AuthProvider>
            )}
          />
          <Route
            exact
            path="/suggestion"
            render={(props) => (
              <AuthProvider>
                <SuggestionPage {...props} />
              </AuthProvider>
            )}
          />
          <Route
            exact
            path="/tenant-page"
            render={(props) => (
              <AuthProvider>
                <TenantPage {...props} />
              </AuthProvider>
            )}
          />
          <Route
            exact
            path="/error-page"
            render={(props) => <ErrorPage {...props} />}
          />
          <Route
            exact
            path="/session-expired"
            render={(props) => <MissingTokenPage type="expired" {...props} />}
          />
          <Route
            exact
            path="/invalid-token"
            render={(props) => <MissingTokenPage type="invalid" {...props} />}
          />
          <Route
            exact
            path="/miniapp-failure"
            render={(props) => <MiniAppFailurePage {...props} />}
          />
        </Switch>
      </Suspense>
    </div>
  );
};

export default Routes;
